  import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
  import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

  export const vsObjectName = "machinePlayerTrackingType";

  const url = "/api/machines/MachinePlayerTrackingType";

  export const machinePlayerTrackingTypeLookupConfig = simpleLookupConfig(
    vsLookupManagementServiceProviderName,
    {
      name: vsObjectName,
      nameSingular: "Player Tracking Type",
      url,
    }
  );
